import type { CSSProperties } from 'react';

const livePulseCss = `
@keyframes live-pulse-ring {
  0% {
    transform: scale(1);
    opacity: 0.55;
  }

  80%,
  100% {
    transform: scale(2.4);
    opacity: 0;
  }
}

@keyframes live-pulse-dot {
  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.72);
  }
}

@media (prefers-reduced-motion: no-preference) {
  .live-pulse-ring {
    animation: live-pulse-ring 1.8s cubic-bezier(0.2, 0.6, 0.4, 1) infinite;
  }

  .live-pulse-dot {
    animation: live-pulse-dot 1.8s ease-in-out infinite;
  }
}
`;

interface LivePulseDotProps {
  color: string;
  size: number;
}

const LivePulseDot = ({ color, size }: LivePulseDotProps) => {
  const livePulseStyle: CSSProperties = {
    position: 'absolute',
    inset: 0,
    borderRadius: '50%',
    background: color,
    transformBox: 'fill-box',
    transformOrigin: 'center center',
  };

  return (
    <span
      style={{
        position: 'relative',
        width: size,
        height: size,
        display: 'inline-flex',
        flexShrink: 0,
      }}
    >
      <style>{livePulseCss}</style>
      <span className="live-pulse-ring" style={livePulseStyle} />
      <span
        className="live-pulse-dot"
        style={{ ...livePulseStyle, position: 'relative', width: size, height: size }}
      />
    </span>
  );
};

export default LivePulseDot;
